module.exports = __webpack_public_path__ + "static/media/footerMenus.2b414895.png";